angular.module('bmsApp.merrymaids.schedule')
	.controller('MMScheduleDailyCtrl', [
		'$window',
		'$scope',
		'$state',
		'$stateParams',
		'$filter',
		'$ngBootbox',
		'$modal',
		'notify',
		'AppSettingsSvc',
		'DirectionSvc',
		'ManualRouteSvc',
		'MMScheduleSvc',
		'MMScheduleDataSvc',
		function ($window,
				  $scope,
				  $state,
				  $stateParams,
				  $filter,
				  $ngBootbox,
				  $modal,
				  notify,
				  AppSettingsSvc,
				  DirectionSvc,
				  ManualRouteSvc,
				  MMScheduleSvc,
				  MMScheduleDataSvc) {

			let protos = {
				route: function () {
					let momentDate = moment(self.date);
					let weekDay = momentDate.format('ddd').toLowerCase();
					// Find relevant work start time
					let workStartTime = self.businessHours[weekDay + '_opens_at'] || '09:00:00';

					return {
						is_ecom: false,
						employees: [],
						job_parts: [],
						route_date: self.date,
						start_postcode: '',
						start_time: workStartTime,
						locked: false,
						visible: true
					};
				}
			};

			function init() {
				if (angular.isDefined($stateParams.date)) {
					self.date = moment($stateParams.date, 'YYYY-MM-DD');
				}
				else {
					self.date = moment();
				}
				// convert date to string since the datepicker will anyway
				self.date = self.date.format('YYYY-MM-DD');
				self.dateInput = self.date;

				AppSettingsSvc.loadBusinessHours()
					.then((response) => {
						self.businessHours = response.data.business_hours;
						loadDate();
					});
				//
			}

			function changeDate() {
				var revert = function () {
					self.dateInput = self.date;
				};
				var load = function () {
					self.date = self.dateInput;
					loadDate();
				};
				if (outstandingChanges()) {
					$ngBootbox.customDialog({
						title: 'Do you need to save?',
						message: 'What would you like to do before changing dates?',
						buttons: {
							cancel: {
								label: 'Cancel',
								className: 'btn btn-default',
								callback: function () {
									// make sure date changes back straight away
									$scope.$apply(function () {
										revert();
									});
								}
							},
							discard: {
								label: 'Don\'t Save',
								className: 'btn btn-danger',
								callback: function () {
									load();
								}
							},
							save: {
								label: 'Save',
								className: 'btn btn-primary',
								callback: function () {
									saveDate()
										.then(function () {
											load();
										});
								}
							}
						}
					});
				}
				else {
					// no changes, simply load
					load();
				}
			}

			function quickDaySelect(days) {
				self.dateInput = moment()
					.add(days, 'days');
				// ng-change seems to get called with existing datepicker when changing the scope variable, uncomment if it doesn't
				// changeDate();
			}

			function loadDate() {
				self.loading = true;
				self.preInvoiceDisabled = moment(self.date).isBefore(moment(), 'day');
				return MMScheduleDataSvc.load({
					date: self.date
				})
					.then(function (response) {
						self.routesOriginal = angular.copy(response.data.route_collection);
						self.routes = angular.copy(response.data.route_collection);
						self.last_route_meta_data = response.data.last_route_meta_data;
						self.options.jobPart = response.data.job_part_collection;
						self.options.employee = response.data.employee_collection;
						self.hasTeams = response.data.day_has_teams;
						self.containsLocked = response.data.contains_locked_routes;
						angular.forEach(self.routesOriginal, function (route) {
							onRouteUpdated(route);
							route.visible = true;
						});
						angular.forEach(self.routes, function (route) {
							onRouteUpdated(route);
							route.visible = true;
						});
						onJobPartListUpdated();
						// update the date in the url
						$state.go('main.merrymaids.schedule.daily', {
							'date': self.date
						}, {
							notify: false
						});
						self.loading = false;
					}, function () {
						notify({
							message: 'Failed to load data.',
							duration: '0',
							classes: 'error'
						});
					});
			}

			function outstandingChanges() {
				// hoping this doesn't slow things down too much...
				return !angular.equals(self.routesOriginal, self.routes);
			}

			function canGetDirections(route) {
				if (angular.isObject(route)) {
					return angular.isObject(route.driver);
				}
			}

			function saveDate(force) {
				self.saving = true;
				force = force || false;
				return MMScheduleDataSvc.save({
					date: self.date,
					last_route_meta_data: self.last_route_meta_data,
					routes: self.routes,
					force: force
				})
					.then(function () {
						notify({
							message: 'Schedule saved successfully.'
						});
						loadDate();
					}, function (errors) {
						if (errors.indexOf('ALREADY_MODIFIED') > -1) {
							$ngBootbox.customDialog({
								message: 'One or more routes have already been modified by another user since editing begun.',
								buttons: {
									cancel: {
										label: 'Cancel',
										className: 'btn btn-default',
										callback: function () {
											// do nothing
										}
									},
									reload: {
										label: 'Reload (LOSE CHANGES)',
										className: 'btn btn-danger',
										callback: function () {
											loadDate();
										}
									},
									force: {
										label: 'Override Previous Changes',
										className: 'btn btn-danger',
										callback: function () {
											saveDate(true);
										}
									}
								}
							});
						}
						else {
							notify({
								message: 'Failed to save data.',
								duration: '0',
								classes: 'error'
							});
						}
					})
					.finally(function () {
						self.saving = false;
					});
			}

			function saveDateBtn() {
				saveDate();
			}

			function addRoute() {
				var route = protos.route();
				self.routes.push(route);
				onRouteUpdated(route);
			}

			function deleteRoute(route) {
				if (!route.locked && routeClosedJobCount(route) === 0 && route.is_ecom === false) {
					$ngBootbox.confirm('Are you sure you want to remove this route?')
						.then(function () {
							// make the job parts and employees available again
							angular.forEach(route.job_parts, function (jobPart) {
								self.options.jobPart.unshift(jobPart);
							});
							route.job_parts.length = 0;
							angular.forEach(route.employees, function (employee) {
								self.options.employee.unshift(employee);
							});
							route.employees.length = 0;
							// mark the route for deletion
							route.delete = true;
						});
				}
			}

			function routeClosedJobCount(route) {
				var count = 0;
				angular.forEach(route.job_parts, function (jobPart) {
					if (jobPart.closed) {
						count++;
					}
				});

				return count;
			}

			function toggleRouteVisibility(route) {
				route.visible = !route.visible;
			}

			function viewDirections(route) {
				if (!outstandingChanges()) {
					var params = {
						date: self.date
					};
					if (angular.isObject(route)) {
						if (canGetDirections(route) !== true) {
							return;
						}
						params.route_ids = [
							route.id
						];
					}
					DirectionSvc.printDirections(params);
				}
			}

			function viewWorksheets(route) {
				var routes;
				var unroutedJobParts;
				if (angular.isObject(route)) {
					routes = [route];
					unroutedJobParts = [];
				}
				else {
					routes = self.routes;
					unroutedJobParts = self.options.jobPart;
				}
				if (!outstandingChanges()) {
					MMScheduleSvc.worksheetsModal(self.date, routes, unroutedJobParts);
				}
			}

			function displayRoutingModal(route) {
				if (angular.isObject(route.driver)) {
					var origin, destination;
					if (angular.isDefined(route.driver.starting_location.lat) && angular.isDefined(route.driver.starting_location.lng)) {
						origin = {
							latitude: route.driver.starting_location.lat,
							longitude: route.driver.starting_location.lng
						};
						destination = angular.copy(origin);
					}
					else {
						origin = route.driver.starting_location.postcode;
						destination = route.driver.starting_location.postcode;
					}
					var manualRoute = {
						origin: origin,
						destination: destination,
						departureTime: new moment((route.start_time || '09:00:00'), 'HH:mm:ss'),
						waypoints: []
					};
					angular.forEach(route.job_parts, function (jobPart) {
						manualRoute.waypoints.push({
							id: jobPart.id,
							latitude: jobPart.job.site.lat,
							longitude: jobPart.job.site.lng,
							postcode: jobPart.job.site.postcode,
							label: jobPart.job.customer.label,
							is_ecom: jobPart.job.is_ecom,
							jobDurationSeconds: jobPart.pre_closed_job_duration_seconds / (route.employees.length || 1),
							preferredTimeLabel: jobPart.preferred_cleaning_time_label
						});
					});
					ManualRouteSvc.displayManualRouteModal(manualRoute)
						.then(function (result) {
							// re-order route job parts to match result.manualRoute.waypoints order
							var sortedRouteJobParts = _.sortBy(route.job_parts, function (routeJobPart) {
								var search = $filter('filter')(result.manualRoute.waypoints, {id: routeJobPart.id}, true)[0];
								// whilst we're getting search results, copy the arrival time from the manual route waypoint to the routeJobPart
								routeJobPart.travel_distance_miles = search.travelDistanceMiles;
								routeJobPart.travel_duration_minutes = (search.travelDurationSeconds / 60).toFixed(1);
								routeJobPart.arrival_time = search.arrivalTime.format('HH:mm:ss');
								return result.manualRoute.waypoints.indexOf(search);
							});
							if (sortedRouteJobParts.length === route.job_parts.length) {
								route.job_parts.length = 0;
								angular.extend(route.job_parts, sortedRouteJobParts);
							}
							else {
								console.info('Something went wrong');
							}
							// update start time, travel time and miles on route
							route.start_time = moment.isMoment(result.manualRoute.departureTime) ? result.manualRoute.departureTime.format('HH:mm:ss') : result.manualRoute.departureTime;
							route.travel_time = result.summary.travelDurationSeconds / 60;
							route.miles = result.summary.travelDistanceMetres / 1609.34;
							route.routed = true;
							console.info(route);
							onRouteUpdated(route);
						});
				}
			}

			function printRoute(route) {
				if (route.id && route.driver && self.methods.outstandingChanges() === false) {
					let paramString = $.param({
						id: route.id,
					});
					$window.open('merrymaids/scheduling/route?' + paramString, '_blank');
				}
			}

			function saveNote(route) {
				let modalInstance = $modal.open({
					animation: true,
					templateUrl: 'ng/merrymaids/schedule/templates/MMScheduleRouteNoteModal.html',
					controller: 'MMScheduleRouteNoteModalCtrl',
					controllerAs: 'Ctrl',
					backdrop: 'static',
					resolve: {
						route: function () {
							return route
						},
					},
				})
				modalInstance.result.then((result) => {
					route.note = result.note
				})
			}

			function setRouteDriver(route, employee) {
				route.driver = employee;
				clearRouteRouted(route);
			}

			function clearRouteRouted(route) {
				route.travel_time = null;
				route.miles = 0;
				route.routed = false;
			}

			function toggleJobPartAddress(jobPart) {
				jobPart.showAddress = !jobPart.showAddress;
			}

			function autoSchedule() {
				if (!self.hasTeams || self.containsLocked) {
					return;
				}
				$ngBootbox.customDialog({
					title: 'Are you sure?',
					message: 'This will erase any route currently in place on this day',
					// className: 'test-class',
					buttons: {
						cancel: {
							label: "Cancel",
							className: "btn-primary",
							callback: function() {}
						},
						yes: {
							label: "Yes",
							className: "btn-success",
							callback: function() {
								self.loading = true;
								return MMScheduleDataSvc.confirmDay({date: self.date}).then((results) => {
									if (results.data.error) {
										self.loading = false;
										notify({
											message: 'Unable to auto schedule this date because ' + results.data.error,
											duration: '0',
											classes: 'error'
										});
									} else {
										loadDate();
										MMScheduleSvc.warningsModal(results.data.warnings, self.date, false);
									}
								});
							}
						},
					}
				});
			}

			function preInvoice() {
				if (!self.preInvoiceDisabled) {
					MMScheduleSvc.preInvoiceModal(self.date);
				}
			}

			function onJobPartListUpdated() {
				var count = self.options.jobPart.length;
				var jobValue = 0;
				var jobDuration = 0;
				angular.forEach(self.options.jobPart, function (jobPart) {
					jobValue += parseFloat(jobPart.subtotal_net) || 0;
					jobDuration += parseInt(jobPart.pre_closed_job_duration_seconds) || 0;
				});
				var jobValueAvg = jobValue / count;
				var jobDurationAvg = jobDuration / count;
				angular.extend(self.jobPartSummary, {
					count: count,
					jobValue: jobValue,
					jobValueAvg: jobValueAvg,
					jobDuration: jobDuration,
					jobDurationAvg: jobDurationAvg
				});
			}

			function onRouteUpdated(route, clearRouted) {
				clearRouted = clearRouted || false;
				var jobValue = 0;
				var jobDuration = 0;
				var travelDuration = (route.travel_time || 0) * 60;
				angular.forEach(route.job_parts, function (jobPart) {
					jobValue += parseFloat(jobPart.subtotal_net) || 0;
					jobDuration += (parseInt(jobPart.pre_closed_job_duration_seconds) || 0) / (route.employees.length || 1);
				});
				var totalDuration = jobDuration + travelDuration;
				var travelDistance = route.miles || 0;
				var estimatedFinishTime = new moment(route.start_time, 'HH:mm:ss').add('s', totalDuration);
				angular.extend(route, {
					summary: {
						targetValue: 0,
						jobValue: jobValue,
						jobDuration: jobDuration,
						travelDuration: travelDuration,
						totalDuration: totalDuration,
						travelDistance: travelDistance,
						estimatedFinishTime: estimatedFinishTime
					}
				});
				// check to see if driver has been removed
				if (angular.isObject(route.driver)) {
					var employeeIds = _.pluck(route.employees, 'id');
					if (employeeIds.indexOf(route.driver.id) == -1) {
						route.driver = undefined;
						clearRouteRouted(route);
					}
				}
				if (clearRouted) {
					clearRouteRouted(route);
				}
			}

			function onJobPartClick(jobPart)
			{
				self.loadingJobPart = true;
				self.jobPartHistory = [];
				MMScheduleDataSvc.jobPartHistory({jobId: jobPart.job.id}).then((response) => {
					self.loadingJobPart = false;
					self.jobPartHistory = response.data.jobParts;
				});
			}

			var self = $scope.MMScheduleDailyCtrl = {
				saving: false,
				loading: false,
				date: undefined,
				dateInput: undefined,
				preInvoiceDisabled: true,
				jobPartHistory: [],
				loadingJobPart: false,
				methods: {
					init: init,
					changeDate: changeDate,
					quickDaySelect: quickDaySelect,
					outstandingChanges: outstandingChanges,
					canGetDirections: canGetDirections,
					saveDate: saveDate,
					saveDateBtn: saveDateBtn,
					addRoute: addRoute,
					deleteRoute: deleteRoute,
					routeClosedJobCount: routeClosedJobCount,
					toggleRouteVisibility: toggleRouteVisibility,
					viewDirections: viewDirections,
					viewWorksheets: viewWorksheets,
					displayRoutingModal: displayRoutingModal,
					printRoute: printRoute,
					saveNote: saveNote,
					setRouteDriver: setRouteDriver,
					toggleJobPartAddress: toggleJobPartAddress,
					autoSchedule: autoSchedule,
					preInvoice: preInvoice,
					onJobPartListUpdated: onJobPartListUpdated,
					onRouteUpdated: onRouteUpdated,
					onJobPartClick: onJobPartClick,
				},
				handlers: {
					route: {
						jobPart: {
							list: {
								onDrop: (targetRoute, jobPart) => {
									let notEcomJobPart = jobPart.job.is_ecom === false;
									let ecomJobPartAndRoute = jobPart.job.is_ecom !== false && targetRoute.is_ecom === true;
									if (notEcomJobPart || ecomJobPartAndRoute) {
										return jobPart;
									}
									else {
										// Don't allow ecom job parts to be moved to non-ecom routes
										return false;
									}
								},
								onInserted: (targetRoute) => {
									self.methods.onRouteUpdated(targetRoute, true);
								},
							},
							draggable: {
								onMoved: (sourceRoute, index) => {
									sourceRoute.job_parts.splice(index, 1);
									self.methods.onRouteUpdated(sourceRoute, true);
								},
							},
						},
					},
					jobPartOption: {
						list: {
							onDrop: (jobPart) => {
								let notEcomJobPart = jobPart.job.is_ecom === false;
								if (notEcomJobPart) {
									return jobPart;
								}
								else {
									// Don't allow ecom job parts to be moved back to unassigned job part list
									return false;
								}
							},
							onInserted: () => {
								self.methods.onJobPartListUpdated();
							},
						},
						draggable: {
							onMoved: (index) => {
								self.options.jobPart.splice(index, 1);
								self.methods.onJobPartListUpdated();
							},
						},
					},
				},
				options: {},
				jobPartSummary: {},
				routesOriginal: [],
				routes: [],
				hasTeams: true,
			}

		}
	]);
